import { render } from "./DeleteSubmissionModal.vue?vue&type=template&id=5efd4fb4&scoped=true"
import script from "./DeleteSubmissionModal.vue?vue&type=script&lang=js"
export * from "./DeleteSubmissionModal.vue?vue&type=script&lang=js"

import "./DeleteSubmissionModal.vue?vue&type=style&index=0&id=5efd4fb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5efd4fb4"]])

export default __exports__